module.exports = __webpack_public_path__ + "static/Sporting_Grotesque-Bold_web-f2f17d263ee43fc27fb0a6f28e2edd60.woff";